import { StudentProxyType } from '@peekapak/types/DataProtocolTypes';
import GreyButton from '../../components/GreyButton/GreyButton';

interface Props {
  isEnableResend: boolean;
  isInviteAccepted: boolean;
  isInviteDeclined: boolean;
  isSendInviteError: boolean;
  isInviteSuppression: boolean;
  onResetError: (event: React.MouseEvent<HTMLButtonElement>) => void;
  sendInviteErrorSid: string | undefined;
  student: StudentProxyType;
}

const ParentInviteButton = ({
  isEnableResend,
  isInviteAccepted,
  isInviteDeclined,
  isSendInviteError,
  isInviteSuppression,
  onResetError,
  sendInviteErrorSid,
  student,
}: Props) => {
  if (isInviteAccepted || isInviteDeclined || isEnableResend || isInviteSuppression) {
    return (
      <GreyButton small minWidth type='submit'>
        Resend
      </GreyButton>
    );
  } else if (isSendInviteError && student.sid === sendInviteErrorSid) {
    return (
      <GreyButton small minWidth onClick={onResetError}>
        Error
      </GreyButton>
    );
  }
  return (
    <GreyButton small minWidth type='submit'>
      Send
    </GreyButton>
  );
};

export default ParentInviteButton;
